"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getConnectToAddresses = ({ localAddress, localConnectedAddresses, receivedConnectedAddresses, }) => {
    return receivedConnectedAddresses.filter((receivedConnectedAddress) => !localConnectedAddresses.includes(receivedConnectedAddress) &&
        receivedConnectedAddress !== localAddress);
};
exports.default = getConnectToAddresses;
//# sourceMappingURL=getConnectToAddresses.js.map